import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
import { motion, AnimatePresence } from 'framer-motion';
import { cn } from '../lib/utils';
const navLinks = [{
  name: 'Services',
  href: '#services'
}, {
  name: 'DTF Transfers',
  href: '#dtf'
}, {
  name: 'Screen Printing',
  href: '#screen'
}, {
  name: 'Embroidery',
  href: '#embroidery'
}, {
  name: 'Apparel',
  href: '#apparel'
}, {
  name: 'About',
  href: '#about'
}];
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={cn('fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b', isScrolled ? 'bg-atomic-black/90 backdrop-blur-md border-white/10 py-3' : 'bg-transparent border-transparent py-5')} data-id="element-118">
      <div className="container mx-auto px-4 md:px-6" data-id="element-119">
        <div className="flex items-center justify-between" data-id="element-120">
          {/* Logo */}
          <a href="/" className="flex items-center gap-3 group" data-id="element-121">
            <img src="https://cdn.magicpatterns.com/uploads/nTH6rvmmBYe1TvsMQVLcBV/Atomic_Logo.png" alt="Print Atomic Logo" className="h-12 w-auto group-hover:drop-shadow-[0_0_8px_rgba(163,230,53,0.6)] transition-all" data-id="element-122" />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-8" data-id="element-123">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-gray-300 hover:text-atomic-green transition-colors" data-id="element-124">
                {link.name}
              </a>)}
          </nav>

          {/* Actions */}
          <div className="hidden lg:flex items-center gap-4" data-id="element-125">
            <Button size="sm" data-id="element-126">Get a Quote</Button>
          </div>

          {/* Mobile Menu Button */}
          <button className="lg:hidden text-white p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-127">
            {isMobileMenuOpen ? <X size={24} data-id="element-128" /> : <Menu size={24} data-id="element-129" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-130">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden bg-atomic-charcoal border-b border-white/10 overflow-hidden" data-id="element-131">
            <div className="container mx-auto px-4 py-6 flex flex-col gap-4" data-id="element-132">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-lg font-medium text-gray-300 hover:text-atomic-green transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-133">
                  {link.name}
                </a>)}
              <div className="pt-4 border-t border-white/10 flex flex-col gap-3" data-id="element-134">
                <Button fullWidth onClick={() => setIsMobileMenuOpen(false)} data-id="element-135">
                  Get a Quote
                </Button>
                <Button variant="outline" fullWidth onClick={() => setIsMobileMenuOpen(false)} data-id="element-136">
                  Contact Us
                </Button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}